export default __webpack_public_path__ + "static/media/DOCTOR_COM.53d49df5.png";